// extracted by mini-css-extract-plugin
export default {"root":"NiJ_Mocy8X","link":"_SXJh0DJV1","link_active":"SGBHgg083A","container":"YRQCNTAXBJ","counterWrapper":"n7Mme95SUv","counter":"SdJ8ws6f2i"};